import PDFFormatterCreator from '../parametersFormatters/PDFFormatterCreator'
import {ChartType, ReportChartType} from '../../constants'
import {DateFormat} from '../../../date_format'
import PDFImageCache from '../../../pdf/PDFImageCache'
import ChartPDFDefinitionBuilder from './ChartPDFDefinitionBuilder'
import {ChartPDFOptions} from './ChartPDFDefinitionPartsConstructors'
import {createPdf, downloadPDF as utilDownloadPdf} from '../../../pdf/utils'
import SimpleTableDefinitionBuilder from './SimpleTableDefinitionBuilder'
import StackedTableDefinitionBuilder from './StackedTableDefinitionBuilder'
import {getCreateDefinitionObjectStrategy, getParametersFormattingStrategy} from './utils'
import {atImgPath} from '../../../atBrowserUtils'

export default class ChartPDFGenerator {

    constructor(onGenerateCb) {
        this.onGeneratePdfCallback = onGenerateCb

        this.lastGeneratedPDF = { // save last generated pdf for prevent new generate on download
            encodedPDF: null,
            fileName: 'file.pdf'
        }

        this.pdfFormatter = new PDFFormatterCreator()
        this.onGenerateBreaker = {needBreak: false}
    }

    /**
     * We cant interrupt pdf generated process, but we can interrupt on generate process
     */
    interruptGeneration() {
        this.onGenerateBreaker.needBreak = true
    }

    downloadPDF() {
        utilDownloadPdf(this.lastGeneratedPDF.encodedPDF, this.lastGeneratedPDF.fileName)
    }

    generatePDF(config) {
        PDFImageCache.preloadImages({
            "logo": {
                "url": window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH
            },
            "filterIcon": {
                "url": atImgPath('filter-for-pdf.png'),
                "saveAlpha": true
            }
        }).then(() => {
            const loadedImage = PDFImageCache.getImage("logo")
            config.logo = {
                imageBase64: loadedImage.image,
                width: loadedImage.width,
                height: loadedImage.height,
            }
            this._generatePDF(config)
        })
    }

    createPDFBuilder(config, paramFormattingStrategy) {
        const selectedParameters = config.selectedParameters
        const isPieChart = config.chartType === ChartType.PIE_CHART

        let tableDefinitionBuilder
        if (isPieChart || !config.useStackColumns) {
            tableDefinitionBuilder = new SimpleTableDefinitionBuilder(
                config.chartType,
                this.pdfFormatter.getValueFormattedFunction(selectedParameters.chartTypeValue),
                this.pdfFormatter.getCategoryToStringFunction(selectedParameters.groupingLevelValue, config.chartType),
                config.totalValue
            )
        } else {
            tableDefinitionBuilder = new StackedTableDefinitionBuilder(
                config.chartType,
                this.pdfFormatter.getValueFormattedFunction(selectedParameters.chartTypeValue),
                this.pdfFormatter.getCategoryToStringFunction(selectedParameters.groupingLevelValue, config.chartType),
                paramFormattingStrategy.getTableHeaders(selectedParameters),
                config.totalValue,
                config.includeOtherUsers
            )
        }

        return new ChartPDFDefinitionBuilder(
            config.logo,
            config.chartType,
            config.pdfPrintParameters.paperSize,
            config.pdfPrintParameters.paperOrientation,
            config.totalValue,
            {
                chartTypeName: paramFormattingStrategy.formatChartPDFHeaderTitle(selectedParameters),
                dateRangeDescription: paramFormattingStrategy.formatChartPDFHeaderDateInformation(selectedParameters),
                filterTexts: paramFormattingStrategy.formatChartPDFFilterInformation(selectedParameters),
                grandTotalDescription: paramFormattingStrategy.formatGrandTotalDescription(selectedParameters)
            },
            this.pdfFormatter.getValueFormattedFunction(selectedParameters.chartTypeValue),
            tableDefinitionBuilder,
        )
    }

    _generatePDF(config) {
        let newBreaker = {
            needBreak: false
        }
        this.onGenerateBreaker = newBreaker

        const selectedParameters = config.selectedParameters
        const paramFormattingStrategy = getParametersFormattingStrategy({
            chartTypeValue: selectedParameters.chartTypeValue,
            selectorsData: config.selectorsData,
            dateFormat: config.dateFormat,
            reportAuthorizationInfo: config.reportAuthorizationInfo
        })
        const ddBuilder = this.createPDFBuilder(config, paramFormattingStrategy)
        const createDDStrategy = getCreateDefinitionObjectStrategy(config.chartType)

        const doc = createPdf(
            createDDStrategy.createDocDefinitionObject(
                ddBuilder,
                config.pagesData,
                config.pdfPrintParameters,
                config.includeOtherUsers
            )
        )

        const currentFileName = paramFormattingStrategy.formatChartPDFFileName(selectedParameters)
        try {
            doc._createDoc(
                ChartPDFOptions,
                (result) => {
                    if (newBreaker.needBreak) {
                        return
                    }

                    this.lastGeneratedPDF = { // save last generated pdf for prevent new generate on download
                        encodedPDF: result,
                        fileName: currentFileName
                    }

                    if (this.onGeneratePdfCallback) {
                        this.onGeneratePdfCallback(result)
                    }
                }
            )

        }
        catch (e) {
            throw e
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/ChartPDFGenerator.js